import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Recharge from '../views/Recharge.vue'
import PrepLesson from '../views/PrepLesson.vue'
import AIChat from '../views/AIChat.vue' // 新增
import User from '../views/User.vue'
import {
	isAuthenticated
} from '@/utils/auth'

Vue.use(VueRouter)

const routes = [{
		path: '/Home',
		name: 'Home',
		component: Home
	},
	{
		path: '/',
		name: 'Login',
		component: Login
	},
	{
		path: '/recharge',
		name: 'Recharge',
		component: Recharge,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/user',
		name: 'User',
		component: User,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/prep-lesson',
		name: 'PrepLesson',
		component: PrepLesson,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/ai-chat',
		name: 'AIChat',
		component: AIChat
	},
	//  {
	//   path: '/ai-chat',
	//   name: 'AIChat',
	//   component: AIChat
	// },
	{
		path: '/lesson-preparation',
		name: 'LessonPreparation',
		component: () => import('@/views/LessonPreparation/LessonPreparation.vue'),
		meta: {
			title: 'AI智能备课系统 - 中国-东盟建筑工程技术专业'
		}
	},
	{
		path: '/homework-diagnosis',
		name: 'HomeworkDiagnosis',
		component: () => import('@/views/HomeworkDiagnosis/HomeworkDiagnosis.vue'),
		meta: {
			title: 'AI智能作业诊断系统 - 中国-东盟建筑工程技术专业'
		}
	},
	{
		path: '/ai-tutor',
		name: 'AITutorSystem',
		component: () => import('@/views/AITutorSystem/AITutorSystem.vue'),
		meta: {
			title: '课后AI辅导系统 - 中国-东盟建筑工程技术专业'
		}
	},
	{
		path: '/ExamSystemHomepage',
		name: 'ExamSystemHomepage',
		component: () => import('@/views/ExamSystemHomepage/ExamSystemHomepage.vue'),
		meta: {
			title: '智能考试评价系统 - 中国-东盟建筑工程技术专业'
		}
	},
	{
		path: '/KnowledgeGraphHome',
		name: 'KnowledgeGraphHome',
		component: () => import('@/views/KnowledgeGraphHome/KnowledgeGraphHome.vue'),
		meta: {
			title: '职业能力协同图谱系统 - 中国-东盟建筑工程技术专业'
		}
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		console.log('--------------',isAuthenticated)
		if (!isAuthenticated()) {
			next({
				path: '/',
				query: {
					redirect: to.fullPath
				}
			})
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router